/* eslint-disable no-restricted-imports */
import React, { useEffect, useState } from "react";
import {
  Button,
  RadioGroup,
  Radio,
  MenuItem,
  Select,
  FormControlLabel
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Toast } from "react-bootstrap";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import { v4 as uuidv4 } from "uuid";
import { getAllZimbraConfig, modifyZimbraConfig } from "../modules/Auth/_redux/adminCrud";

export function Pop3Page() {
  const useStyles = makeStyles(theme => ({
    labelStyle: {
      display: "inline-block",
      marginTop: "-2px",
      fontSize: "1.2rem",
      width: "160px"
    },
    inputStyle: {
      display: "inline-flex",
      width: "200px",
      height: "32px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      borderRadius: "4px 4px 4px 4px",
      ":active": {
        border: "1px solid #c8cace"
      }
    },
    selectStyle: {
      display: "inline-flex",
      width: "200px",
      height: "32px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      background: "transparent",
      marginRight: "12px",
      borderRadius: "4px 4px 4px 4px",
      ":active": {
        background: "transparent"
      }
    },
    buttonStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1.2rem",
      marginRight: "12px"
    },
    buttonSmallStyle: {
      width: "60px",
      height: "28px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem"
      //   marginLeft: "12px"
    },

    buttonDisableStyle: {
      color: "#b4b5b8",
      border: "1px solid #b4b5b8",
      background: "#ebedf1"
    },
    buttonClearStyle: {
      width: "32px",
      height: "32px",
      border: "0px solid #123456",
      marginRight: "12px",
      "&:hover": {
        backgroundColor: "transparent !important"
      }
    },
    searchStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem",
      float: "right"
    },
    dateStyle: {
      width: "160px",
      height: "32px",
      color: "#123456",
      border: "1px solid #c8cace",
      fontSize: "1rem",
      marginRight: "36px",
      textAlign: "left",
      background: "transparent",
      borderRadius: "4px 4px 4px 4px",
      paddingLeft: "12px"
    },

    boxContainer: {
      display: "inline-block",
      width: "100%",
      verticalAlign: "top"
    },
    box30Style: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    boxStyle: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    subTitleStyle: {
      display: "block",
      fontSize: "1.2rem",
      width: "100%",
      marginBottom: "12px",
      fontWeight: "bold",
      alignItems: "baseline",
      color: "#555555"
    },
    subTitleLastStyle: {
      fontSize: "1rem",
      //   fontWeight: "bold",
      color: "#555555",
      marginTop: "-8px"
    },
    headerRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px"
    },
    headerColStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "50%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      background: "#dfe2e8",
      height: "44px"
    },
    dataCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      //   background: "#dfe2e8",
      height: "44px"
    },
    dataRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px",
      borderBottom: "1px solid lightgray"
    },
    width100Style: {
      width: "100%"
    },
    dataColStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "50%",
      height: "44px"
    },
    dataCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      height: "44px"
    },
    dataColSmallStyle: {
      display: "inline-block",
      fontSize: "12px",
      textAlign: "center",
      width: "50%",
      height: "44px",
      overflow: "hidden",
      lineHeight: "16px",
      paddingTop: "6px"
    },
    dataColTextStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "left",
      //   width: "50%",
      height: "44px"
    },
    radioStyle: {
      width: "80px",
      fontSize: "1rem",
      //   background: "transparent",
      color: "#555555",
      borderColor: "#dfe2e8",
      //   paddingTop: "6px",
      //   "&:hover": {
      //     color: "#123456",
      //     backgroundColor: "#eae4f5 !important"
      //   },
      "&:active": {
        color: "white",
        backgroundColor: "#123456 !important"
      }
    },
    selected: {
      color: "white",
      backgroundColor: "#123456 !important"
    }
  }));

  const [backupTimeList, setBackupTimeList] = useState([
    {
      date: "TUE",
      hour: "04",
      minute: "40"
    },
    {
      date: "SUN",
      hour: "02",
      minute: "10"
    },
    {
      date: "FRI",
      hour: "13",
      minute: "30"
    }
  ]);

  const Styles = useStyles();
  const [refresh, setRefresh] = React.useState(false);
  //   const [useBackupAuto, setUseBackupAuto] = React.useState("FALSE");


  const [showAsk, setShowAsk] = React.useState(false);

  const [zimbraPop3ServerEnabled, setZimbraPop3ServerEnabled] = React.useState(
    "TRUE"
  );
  const [
    zimbraPop3SSLServerEnabled,
    setZimbraPop3SSLServerEnabled
  ] = React.useState("TRUE");
  const [
    zimbraPop3CleartextLoginEnabled,
    setZimbraPop3CleartextLoginEnabled
  ] = React.useState("FALSE");
  const [
    zimbraPop3MaxConnections,
    setZimbraPop3MaxConnections
  ] = React.useState(102400);

  const handleChangePop3Enabled = event => {
    setZimbraPop3ServerEnabled(event.target.value);
  };

  const handleChangeSslEnabled = event => {
    setZimbraPop3SSLServerEnabled(event.target.value);
  };

  const handleChangeClearTextEnabled = event => {
    setZimbraPop3CleartextLoginEnabled(event.target.value);
  };

  const handleChangeNumThread = event => {
    setZimbraPop3MaxConnections(event.target.value);
  };

  const handlePressSave = () => {
    const config = [
      {
        name: "zimbraPop3ServerEnabled",
        value: zimbraPop3ServerEnabled
      },
      {
        name: "zimbraPop3SSLServerEnabled",
        value: zimbraPop3SSLServerEnabled
      },
      {
        name: "zimbraPop3CleartextLoginEnabled",
        value: zimbraPop3CleartextLoginEnabled
      },
      {
        name: "zimbraPop3MaxConnections",
        value: zimbraPop3MaxConnections
      }
    ];

    modifyZimbraConfig(config).then(result => {
      console.log("modifyZimbraConfig", result);

      setRefresh(!refresh);
    })
    .catch(error => {
      console.log(error)
    })
  };

  const parseConfig = (array, name, defaultValue) => {
    const ar = array.filter(a => a.n === name);
    if (ar == null || ar.length === 0) return defaultValue;

    return ar[0]._content;
  };

  const initConfig = () => {
    getAllZimbraConfig().then(result => {
      console.log("modifyZimbraConfig", result.data.allConfig);

      const zimbraPop3ServerEnabled = parseConfig(
        result.data.allConfig,
        "zimbraPop3ServerEnabled",
        "TRUE"
      );
      const zimbraPop3SSLServerEnabled = parseConfig(
        result.data.allConfig,
        "zimbraPop3SSLServerEnabled",
        "TRUE"
      );
      const zimbraPop3CleartextLoginEnabled = parseConfig(
        result.data.allConfig,
        "zimbraPop3CleartextLoginEnabled",
        "TRUE"
      );
      const zimbraPop3MaxConnections = parseConfig(
        result.data.allConfig,
        "zimbraPop3MaxConnections",
        200
      );

      setZimbraPop3ServerEnabled(zimbraPop3ServerEnabled);
      setZimbraPop3SSLServerEnabled(zimbraPop3SSLServerEnabled);
      setZimbraPop3CleartextLoginEnabled(zimbraPop3CleartextLoginEnabled);
      setZimbraPop3MaxConnections(zimbraPop3MaxConnections);
    })
    .catch(error => {
      console.log(error)
    })
  };

  useEffect(() => {
    initConfig();
  }, [refresh]);

  return (
    <>
      <div
        style={{
          marginTop: "12px",
          marginLeft: "-12px",
          height: "100%"
        }}
      >
        {/* -------------------- */}

        <div className={Styles.boxContainer}>
          <div className={Styles.boxStyle}>
            <div className={Styles.subTitleStyle}>
              <Button
                className={Styles.buttonStyle}
                onClick={() => {
                  handlePressSave();
                }}
              >
                저장
              </Button>
            </div>

            <div className={Styles.subTitleLastStyle}>
              {/* <InputLabel htmlFor="age-simple">메일백업 / PC에 저장</InputLabel> */}
              <div className={Styles.labelStyle}>POP3 사용여부</div>
              <RadioGroup
                label="사용함"
                name="gender1"
                style={{
                  display: "inline-block",
                  fontSize: "1.2rem"
                }}
                // className={classes4.group}
                value={zimbraPop3ServerEnabled}
                onChange={handleChangePop3Enabled}
              >
                <FormControlLabel
                  value="TRUE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="사용함"
                />
                <FormControlLabel
                  value="FALSE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="사용안함"
                />
              </RadioGroup>
            </div>

            <div className={Styles.subTitleLastStyle}>
              {/* <InputLabel htmlFor="age-simple">메일백업 / PC에 저장</InputLabel> */}
              <div className={Styles.labelStyle}>SSL 적용</div>
              <RadioGroup
                name="gender1"
                style={{
                  display: "inline-block",
                  fontSize: "1.2rem"
                }}
                // className={classes4.group}
                value={zimbraPop3SSLServerEnabled}
                onChange={handleChangeSslEnabled}
              >
                <FormControlLabel
                  value="TRUE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="사용함"
                />
                <FormControlLabel
                  value="FALSE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="사용안함"
                />
              </RadioGroup>
            </div>

            <div className={Styles.subTitleLastStyle}>
              {/* <InputLabel htmlFor="age-simple">메일백업 / PC에 저장</InputLabel> */}
              <div className={Styles.labelStyle}>비암호화 로그인</div>
              <RadioGroup
                name="gender1"
                style={{
                  display: "inline-block",
                  fontSize: "1.2rem"
                }}
                // className={classes4.group}
                value={zimbraPop3CleartextLoginEnabled}
                onChange={handleChangeClearTextEnabled}
              >
                <FormControlLabel
                  value="TRUE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="허용함"
                />
                <FormControlLabel
                  value="FALSE"
                  style={{
                    marginTop: "4px",
                    marginRight: "12px",
                    fontSize: "1.2rem"
                  }}
                  control={<Radio />}
                  label="차단함"
                />
              </RadioGroup>
            </div>

            <div
              className={Styles.subTitleLastStyle}
              style={{ marginTop: "6px" }}
            >
              <div className={Styles.labelStyle}>동시접속 가능수</div>

              <Select
                value={zimbraPop3MaxConnections}
                className={Styles.selectStyle}
                onChange={handleChangeNumThread}
                style={{
                  width: "80px"
                }}
              >
                <MenuItem value="--">갯수선택</MenuItem>
                <MenuItem value="5">5</MenuItem>
                <MenuItem value="10">10</MenuItem>
                <MenuItem value="50">50</MenuItem>
                <MenuItem value="100">100</MenuItem>
                <MenuItem value="200">200</MenuItem>
                <MenuItem value="300">300</MenuItem>
                <MenuItem value="400">400</MenuItem>
                <MenuItem value="500">500</MenuItem>
                <MenuItem value="1000">1000</MenuItem>
              </Select>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={showAsk}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"삭제"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            선택한 항목을 삭제하시겠습니까?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => {
              setShowAsk(false);
            }}
          >
            아니오
          </Button>
          <Button
            color="primary"
            autoFocus
            onClick={() => {
              setShowAsk(false);
            }}
          >
            예
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
